export default {

	// a deterministic avatar background colour from a player's initial, so a
	// player with no avatar gets a stable colour behind their letter. Spread
	// across the hue wheel by character; medium saturation/lightness so white
	// text on top stays readable.
	avatarColor: function(initial) {

		var ch = String(initial || '?').trim().charAt(0).toUpperCase()
		var code = ch.charCodeAt(0) || 63

		var hue = (code * 37) % 360

		return 'hsl(' + hue + ', 52%, 48%)'

	},

	// a random token in the geekgroup unambiguous alphabet (no 0/1/i/l/o)
	token: function(length) {

		var alphabet = 'abcdefghjkmnpqrstuvwxyz23456789'
		var token = ''

		for (var i = 0; i < (length || 16); i++) {

			token += alphabet.charAt(Math.floor(Math.random() * alphabet.length))

		}

		return token

	},

	// the current daily puzzle date by the 10:00 Europe/London rollover (the same
	// boundary Boxart\Puzzle and the End countdown use). Returns 'YYYY-MM-DD'.
	// Shared by Daily.vue (rollover polling) and the store (result sync), so the
	// "what is today's puzzle" rule lives in exactly one place.
	puzzleDate: function() {

		var parts = new Intl.DateTimeFormat('en-GB', {
			timeZone: 'Europe/London',
			hour12: false,
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit'
		}).formatToParts(new Date())

		var get = function(type) {
			var p = parts.find(function(x) { return x.type === type })
			return p ? parseInt(p.value, 10) : 0
		}

		var h = get('hour')
		if (h === 24) h = 0

		// midnight UTC of the London calendar day, minus a day before 10:00
		var ms = Date.UTC(get('year'), get('month') - 1, get('day')) - (h < 10 ? 86400000 : 0)

		return new Date(ms).toISOString().slice(0, 10)

	}

}
